import React from 'react';
import PublicHeader from './PublicHeader';

// This layout only includes the header, without the footer
const PublicHeaderLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Skip link for keyboard navigation (WCAG 2.4.1) */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-[100] focus:bg-blue-600 focus:text-white focus:p-4 focus:font-semibold"
      >
        Skip to main content
      </a>
      <PublicHeader />
      <main id="main-content" tabIndex={-1} className="w-full max-w-[875px] mx-auto px-4 py-8 flex-grow focus:outline-none">
        {children}
      </main>
    </div>
  );
};

export default PublicHeaderLayout;